import { parseNoteContent } from "./modulePaymentNoteUtils";
import { formatTermSwapTimestamp } from "./termSwapNoteUtils";

const SUPERADMIN_TERM_EDIT_MARKER = /\[SUPERADMIN_TERM_EDIT\]([\s\S]*?)\[\/SUPERADMIN_TERM_EDIT\]/;

export const SUPERADMIN_TERM_EDIT_WARNING_LABELS = {
  paid_invoice_unchanged:
    "Paid or partially paid provider invoice — invoice lines were left unchanged; review manually.",
  manage_admissions_not_updated:
    "These changes are not reflected in the Manage Admissions term schedule — verify the admission record.",
  provider_invoice_auto_updated:
    "Provider invoice was auto-updated where applicable; please confirm it is correct.",
};

export const formatSuperAdminTermEditWarnings = (warnings = []) =>
  (warnings || [])
    .filter((w) => w && w !== "none")
    .map((w) => SUPERADMIN_TERM_EDIT_WARNING_LABELS[w] || String(w).replace(/_/g, " "));

export const parseSuperAdminTermEditNote = (noteText) => {
  const raw = (noteText || "").trim();
  if (!raw) return null;

  const marker = raw.match(SUPERADMIN_TERM_EDIT_MARKER);
  if (!marker) return null;

  try {
    const data = JSON.parse(marker[1]);
    return {
      source: data.source || "MANAGE_ADMISSIONS",
      termNumber: data.termNumber != null ? Number(data.termNumber) : null,
      actorName: data.actorName || "Super Admin",
      timestamp: data.timestamp || null,
      auditId: data.auditId != null ? Number(data.auditId) : null,
      changes: Array.isArray(data.changes) ? data.changes : [],
      warnings: Array.isArray(data.warnings) ? data.warnings : [],
    };
  } catch {
    return null;
  }
};

export const isSuperAdminTermEditNote = (note) => {
  const { text } = parseNoteContent(note?.text || "");
  return Boolean(parseSuperAdminTermEditNote(text));
};

export const formatSuperAdminTermEditTimestamp = formatTermSwapTimestamp;

export const superAdminTermEditSourceLabel = (source) => {
  if (source === "DIRECT_ACCOUNT") return "Direct Account";
  return "Manage Admissions";
};
